export function isDefined<T = any>(obj: T | undefined): obj is T {
	return obj !== undefined
}
